/*
 *
 * GlobalLanguageProvider
 *
 */

import { memo } from "react";

import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import { compose } from "redux";

export let intl = null;

export function GlobalLanguageProvider(props) {
  intl = useIntl();

  return props.children;
}

GlobalLanguageProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default compose(memo)(GlobalLanguageProvider);
